// Copyright (c) 2016 Deere & Company

import React, {PropTypes} from 'react';
import EmissionsPartSearchButtonGroup from './emissions-part-search-button-group';
import LabeledCriteria from '../../../shared/components/labeled-criteria';

const EmissionsPartSearchCriteria = props =>
    <div className='emissions-part-search-criteria'>
        <div className='part-number-criteria'>
            <LabeledCriteria
                className='part-number-criteria'
                isRequired={true}
                label='PART_NUMBER'
                maxLength={18}
                onInputChange={props.onPartNumberSearch}
                placeholder='ENTER_A_PART_NUMBER'
                type='text'
                value={props.partNumber}
            />
        </div>
        <EmissionsPartSearchButtonGroup
            onCriteriaReset={props.onCriteriaReset}
            onPartSearchExecute={props.onPartSearchExecute}
            partNumber={props.partNumber}
        />
    </div>;

EmissionsPartSearchCriteria.displayName = 'EmissionsPartSearchCriteria';
EmissionsPartSearchCriteria.propTypes = {
    onCriteriaReset: PropTypes.func.isRequired,
    onPartNumberSearch: PropTypes.func.isRequired,
    onPartSearchExecute: PropTypes.func.isRequired,
    partNumber: PropTypes.string.isRequired
};

export default EmissionsPartSearchCriteria;



// WEBPACK FOOTER //
// ./src/reports/emissions-part-search/components/emissions-part-search-criteria.js